import { ArrowLeft, Home } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

function ComingSoonPage() {
  const navigate = useNavigate()

  return (
    <main className="page-container coming-soon-page">
      <section className="coming-soon-card" aria-labelledby="coming-soon-title">
        <span className="eyebrow">功能开发中</span>
        <h1 id="coming-soon-title">功能开发中</h1>
        <p>该功能正在开发中，后续会逐步开放。</p>
        <div className="coming-soon-actions">
          <button type="button" className="primary-button" onClick={() => navigate('/')}>
            <Home size={16} />
            返回首页
          </button>
          <button type="button" className="secondary-button" onClick={() => navigate(-1)}>
            <ArrowLeft size={16} />
            返回上一页
          </button>
        </div>
      </section>
    </main>
  )
}

export default ComingSoonPage
